export const funnelReviewsFilterLego = [
	'funnelReviews.review1',
	'funnelReviews.review2',
	'funnelReviews.review3',
];
